import { Api } from '@monorepo/shared/apiClient';
import {
  InspectionsCacheEvents,
  invalidateInspectionsCache,
} from '@monorepo/shared/cacheRegisters/complianceCalendar/inspectionsCacheRegister';
import {
  invalidateTasksCache,
  TasksCacheEvents,
} from '@monorepo/shared/cacheRegisters/complianceCalendar/tasksCacheRegister';
import {
  invalidateProjectUsersCache,
  ProjectUsersCacheEvents,
} from '@monorepo/shared/cacheRegisters/users/projectUsersCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseRemoveUserFromProjectParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export function useRemoveUserFromProject(
  params?: UseRemoveUserFromProjectParams,
) {
  return useMutation(Api.removeUserFromProject, {
    ...params?.config,
    onSuccess: (data, variables) => {
      const { projectId } = variables;
      invalidateProjectUsersCache(ProjectUsersCacheEvents.DELETE, {
        projectId,
      });

      // TODO: may not need to invalidate these caches once calendar_events
      // stays in sync with assignees
      // reference: https://github.com/Mapistry/core-issues/issues/8025
      invalidateTasksCache(TasksCacheEvents.UPSERT, { projectId });
      invalidateInspectionsCache(InspectionsCacheEvents.UPDATE, { projectId });

      return params?.config?.onSuccess?.(data, variables);
    },
    onError: (error, variables, rollback) =>
      params?.config?.onError?.(error, variables, rollback),
  });
}
